<template>
  <div>
    <div v-for="item in itemList" :key="item.index+item.id">
      <editorial-content-info-box :item="item"/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {helpers} from "@piveau/piveau-hub-ui-modules";
import {groupBy, has, toPairs, uniqBy} from "lodash-es";
import EditorialContentInfoBox from "@/components/search/editorial-content/EditorialContentInfoBox";

const { getImg, getTranslationFor, truncate } = helpers;

export default {
  name: "EditorialContentList",
  components: {EditorialContentInfoBox},
  data() {
    return {
      baseUrl: this.$env.api.baseUrl
    }
  },
  computed: {
    ...mapGetters("search", ["getEditorialContentItems", "getCombinedItems"]),
    locale() {
      return this.$route.query.locale;
    },
    itemList() {
      return this.getEditorialContentItems;
    }
  },
  methods: {
    getImg,
    getTranslationFor,
    truncate,
    getCatalogImage(catalog) {
      return this.$env.content.catalogs.useCatalogCountries
        ? `${this.$env.content.catalogs.defaultCatalogImagePath}/${has(catalog, "country.id")
          ? catalog.country.id
          : this.$env.content.catalogs.defaultCatalogCountryID
        }`
        : `${this.$env.content.catalogs.defaultCatalogImagePath}/${has(catalog, "id")
          ? catalog.id
          : this.$env.content.catalogs.defaultCatalogID
        }`;
    },
    /**
     * @description Removes the duplicates of the given array
     * @param array {Array} - The array to remove duplicates from
     * @returns {Array}
     */
    removeDuplicatesOf(array) {
      const correctedFormatArray = array.map((format) => ({
        ...format,
        id: this.getBadgeFormat(format.id),
        label: this.getBadgeFormat(format.label),
      }));
      // sorts after # of occurences (highest occurence first)
      // possibility #1
      const sortedArray = toPairs(groupBy(correctedFormatArray, "id")).sort(
        (a, b) => b[1].length - a[1].length
      );
      const onlyFormatObjectsArray = sortedArray.map((arr) => arr[1][0]);
      // lodash uniqBy funtion removes duplicate id´s from array of objects
      const uniqById = uniqBy(onlyFormatObjectsArray, "id");
      return uniqBy(uniqById, "label");
    },
    /**
     * @description Cuts badge format string (max 8 chars)
     * @param label {String} - badge label or id (e.g. csv)
     */
    getBadgeFormat(label) {
      return this.truncate(label, 8, true);
    },
    datasetsRoute(catalogId) {
      return {
        path: `/catalogues/${catalogId}`,
        query: {
          locale: this.$route.query.locale
        }
      }
    },
    getCatalogLanguages(catalog) {
      return has(catalog, "country.id")
        ? [catalog.country.id].concat(catalog.languages)
        : catalog.languages;
    },
  }
}
</script>
